import * as React from "react"
import { sanitize } from "§/src/utils/functions"

// Internal
import "./_tile-content-downloads.scss"

// Utils
import UniversalLink from "§/src/utils/UniversalLink"

const TileContentDownloads = ({
  target,
  downloadstitle,
  downloadsfiles = [],
  downloadFile,
  ondownload,
  isInverted = false,
  ...props
}) => {
  const atomClassName = "tile-content-downloads"
  const atomClass =
    props?.className !== undefined
      ? atomClassName + " " + props?.className
      : atomClassName

  const DatePrinter = ({ date, show }) => (
    <div className={"date"}>
      <p
        className="fs-14 fw-semibold text-uppercase m-0"
        style={{ color: show ? "#000" : "#e4eaf0" }}
      >
        {date}
      </p>
    </div>
  )

  const BundleTitle = ({ file }) =>
    file && file.bundle ? <p className="bundle-title m-0">{file.bundle}</p> : null

  const hasDownloadsFiles = Array.isArray(downloadsfiles) && downloadsfiles.length > 0
  const firstFile = hasDownloadsFiles ? downloadsfiles[0] : null
  const hasBundle = firstFile && firstFile.bundle

  return (
      <div className={hasBundle ? atomClass + ' bundle ' : atomClass + ' normal'}>
        <BundleTitle
          file={
            downloadsfiles && downloadsfiles.length ? downloadsfiles[0] : null
          }
        />
        {downloadstitle && (
          <div
            className={"fs-14 mb-2"}
            dangerouslySetInnerHTML={{
              __html: sanitize(downloadstitle ?? ""),
            }}
          />
        )}
        <div className="d-flex flex-column gap-2">
          {(downloadsfiles || []).map((doc, index) => {
            // Garantisce che abbiamo un array valido per file, anche se doc è undefined
            const fileArray = doc?.files || (doc?.file ? [doc.file] : []);
            return fileArray.map((file, fIndex) => {
              function formatSizeUnits(bytes) {
                if (bytes >= 1073741824) {
                  bytes = (bytes / 1073741824).toFixed(2) + " GB"
                } else if (bytes >= 1048576) {
                  bytes = (bytes / 1048576).toFixed(2) + " MB"
                } else if (bytes >= 1024) {
                  bytes = (bytes / 1024).toFixed(2) + " KB"
                } else if (bytes > 1) {
                  bytes = bytes + " bytes"
                } else if (bytes === 1) {
                  bytes = bytes + " byte"
                } else {
                  bytes = "0 bytes"
                }
                return bytes
              }

              const fancyFileSize = file?.fileSize
                ? formatSizeUnits(file?.fileSize)
                : null

              const fileCategory = doc?.filters?.category?.label
              const fileExtension = file?.extension
              const fileMimeType = file?.mimeType

              // Include mimeType served by layouter downloader
              let finalExtension
              if(fileMimeType === 'application/pdf'){
                finalExtension = "pdf"
              } else {
                finalExtension = fileExtension
              }

              return (
                <div
                  key={`document-${index}-${fIndex}`}
                  className={`download-element p-3 ${
                    isInverted ? `isInverted` : ``
                  }`}
                >
                  <div
                    className={
                      "d-flex flex-row align-items-center gap-2 gap-md-3"
                    }
                  >
                    {doc?.date ? (
                      <DatePrinter date={doc?.date} show={fIndex === 0} />
                    ) : (
                      <div className={"icon"}>
                        <svg
                          width="51"
                          height="51"
                          viewBox="0 0 51 51"
                          fill="none"
                        >
                          <path
                            d="M12.9215 44.9098C11.7923 44.9098 10.877 43.9944 10.877 42.8653V8.10825C10.877 6.97909 11.7923 6.06372 12.9215 6.06372H28.4309C28.9731 6.06372 29.4931 6.27913 29.8766 6.66255L38.9016 15.6875C39.285 16.071 39.5004 16.591 39.5004 17.1332V42.8653C39.5004 43.9944 38.585 44.9098 37.4559 44.9098H12.9215Z"
                            stroke="#005FB6"
                            strokeWidth="2.5"
                          />
                          <path
                            d="M29.2773 6.75659V15.5935C29.2773 16.7227 30.1927 17.638 31.3219 17.638H40.1588"
                            stroke="#005FB6"
                            strokeWidth="1.5"
                          />
                        </svg>
                      </div>
                    )}
                    <div className={"file-description w-100 pe-3"}>
                      <p
                        className="title mb-0"
                        dangerouslySetInnerHTML={{
                          __html: sanitize(file?.title || ''),
                        }}
                      />
                      {doc?.content && (
                        <p
                          className="fs-12 content mb-0"
                          dangerouslySetInnerHTML={{
                            __html: sanitize(doc?.content || ''),
                          }}
                        />
                      )}

                      <div className="file-info">
                        {fileCategory && (
                          <span className="file-cat">{fileCategory}</span>
                        )}
                        {finalExtension && (
                          <span className="file-ext">.{finalExtension}</span>
                        )}
                        {fancyFileSize && (
                          <span className="file-size">{fancyFileSize}</span>
                        )}
                      </div>
                    </div>

                    {doc?.langs && Array.isArray(doc.langs) && doc.langs.length > 0 && doc?.langFiles && (
                      <div className="languageLink">
                        {doc.langs.map(lang => (
                          <a
                            key={lang}
                            href={
                              doc.langFiles[lang]?.mediaItemUrl ||
                              doc.langFiles[lang]?.url
                            }
                            className="asset-block__lang-link"
                            target={finalExtension === "pdf" ? "_blank" : target}
                            rel="nofollow"
                          >
                            {lang}
                          </a>
                        ))}
                      </div>
                    )}

                    <UniversalLink
                      className={doc?.langs && Array.isArray(doc.langs) && doc.langs.length > 0 ? "" : "stretched-link"}
                      to={file?.mediaItemUrl || file?.url || '#'}
                      target={finalExtension === "pdf" ? "_blank" : target}
                      rel="nofollow"
                    >
                      <svg
                        width="30"
                        height="29"
                        viewBox="0 0 30 29"
                        fill="none"
                      >
                        <path
                          d="M19.7583 9.69006L14.9924 14.8675L10.5049 9.69006"
                          stroke="#005FB6"
                          strokeWidth="1.80468"
                          strokeLinecap="square"
                        />
                        <path
                          d="M15.1318 14.0202V4.70081"
                          stroke="#005FB6"
                          strokeWidth="1.80468"
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M6.21289 17.6296V21.8657H23.9909V17.6296"
                          stroke="#005FB6"
                          strokeWidth="1.80468"
                          strokeLinecap="square"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </UniversalLink>
                  </div>
                </div>
              )
            })
          })}
        </div>
      </div>
  )
}

export default TileContentDownloads
